export class PageNumberNotFoundError extends Error {
  constructor(galleryName: string, page: number, additionalMessage: string) {
    super(`Gallery [${galleryName}] with page [${page}] was not found. ${additionalMessage}`)
    this.name = this.constructor.name
  }
}
